import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.model.canLoadMore}}
  {{hide-application-footer}}
{{/if}}

{{body-class "users-page"}}
<section>
  <LoadMore
    @selector=".directory-table .directory-table__cell"
    @action={{action "loadMore"}}
  >
    <div class="container">
      <div class="users-directory directory">
        <span>
          <PluginOutlet
            @name="users-top"
            @connectorTagName="div"
            @outletArgs={{hash model=this.model}}
          />
        </span>
        <div class="directory-controls">
          <div class="period-controls">
            <PeriodChooser
              @period={{this.period}}
              @onChange={{fn (mut this.period)}}
              @fullDay={{false}}
            />
            {{#if this.lastUpdatedAt}}
              <div class="directory-last-updated">
                {{i18n "directory.last_updated"}}
                {{this.lastUpdatedAt}}
              </div>
            {{/if}}
          </div>
          <div class="inline-form">
            <label class="total-rows">
              {{#if this.model.totalRows}}
                {{i18n "directory.total_rows" count=this.model.totalRows}}
              {{/if}}
            </label>
            <Input
              @value={{readonly this.nameInput}}
              placeholder={{i18n "directory.filter_name"}}
              class="filter-name no-blur"
              {{on "input" (with-event-value this.onUsernameFilterChanged)}}
            />
            {{#if this.showGroupFilter}}
              <ComboBox
                @value={{this.group}}
                @content={{this.groupOptions}}
                @onChange={{this.groupChanged}}
                @options={{hash none="directory.group.all"}}
                class="directory-group-selector"
              />
            {{/if}}
            {{#if this.currentUser.staff}}
              <DButton
                @icon="wrench"
                @action={{this.showEditColumnsModal}}
                class="btn-default open-edit-columns-btn"
              />
            {{/if}}
            <PluginOutlet
              @name="users-directory-controls"
              @outletArgs={{hash model=this.model}}
            />
          </div>
        </div>

        <ConditionalLoadingSpinner @condition={{this.isLoading}}>
          {{#if this.model.length}}
            <DirectoryTable
              @items={{this.model}}
              @columns={{this.columns}}
              @showTimeRead={{this.showTimeRead}}
              @order={{this.order}}
              @asc={{this.asc}}
            />
            <ConditionalLoadingSpinner @condition={{this.model.loadingMore}} />
          {{else}}
            <div class="empty-state">
              <div class="empty-state-body">
                <p>
                  {{#if this.name}}
                    {{i18n "directory.no_results_with_search"}}
                  {{else}}
                    {{i18n "directory.no_results.body"}}
                    {{#if this.currentUser.staff}}
                      {{html-safe
                        (i18n
                          "directory.no_results.extra_body" basePath=(base-path)
                        )
                      }}
                    {{/if}}
                  {{/if}}
                </p>
              </div>
            </div>
          {{/if}}
        </ConditionalLoadingSpinner>
      </div>
    </div>
  </LoadMore>
</section>
*/
{
  "id": "SHCMmJZI",
  "block": "[[[41,[30,0,[\"model\",\"canLoadMore\"]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,[28,[35,2],[\"users-page\"],null]],[1,\"\\n\"],[10,\"section\"],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@selector\",\"@action\"],[\".directory-table .directory-table__cell\",[28,[37,4],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"container\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"users-directory directory\"],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[8,[39,5],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"users-top\",\"div\",[28,[37,6],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"directory-controls\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"period-controls\"],[12],[1,\"\\n            \"],[8,[39,7],null,[[\"@period\",\"@onChange\",\"@fullDay\"],[[30,0,[\"period\"]],[28,[37,8],[[28,[37,9],[[30,0,[\"period\"]]],null]],null],false]],null],[1,\"\\n\"],[41,[30,0,[\"lastUpdatedAt\"]],[[[1,\"              \"],[10,0],[14,0,\"directory-last-updated\"],[12],[1,\"\\n                \"],[1,[28,[35,10],[\"directory.last_updated\"],null]],[1,\"\\n                \"],[1,[30,0,[\"lastUpdatedAt\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"inline-form\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"total-rows\"],[12],[1,\"\\n\"],[41,[30,0,[\"model\",\"totalRows\"]],[[[1,\"                \"],[1,[28,[35,10],[\"directory.total_rows\"],[[\"count\"],[[30,0,[\"model\",\"totalRows\"]]]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n            \"],[8,[39,11],[[16,\"placeholder\",[28,[37,10],[\"directory.filter_name\"],null]],[24,0,\"filter-name no-blur\"],[4,[38,13],[\"input\",[28,[37,14],[[30,0,[\"onUsernameFilterChanged\"]]],null]],null]],[[\"@value\"],[[28,[37,12],[[30,0,[\"nameInput\"]]],null]]],null],[1,\"\\n\"],[41,[30,0,[\"showGroupFilter\"]],[[[1,\"              \"],[8,[39,15],[[24,0,\"directory-group-selector\"]],[[\"@value\",\"@content\",\"@onChange\",\"@options\"],[[30,0,[\"group\"]],[30,0,[\"groupOptions\"]],[30,0,[\"groupChanged\"]],[28,[37,6],null,[[\"none\"],[\"directory.group.all\"]]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"              \"],[8,[39,16],[[24,0,\"btn-default open-edit-columns-btn\"]],[[\"@icon\",\"@action\"],[\"wrench\",[30,0,[\"showEditColumnsModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[8,[39,5],null,[[\"@name\",\"@outletArgs\"],[\"users-directory-controls\",[28,[37,6],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[8,[39,17],null,[[\"@condition\"],[[30,0,[\"isLoading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"model\",\"length\"]],[[[1,\"            \"],[8,[39,18],null,[[\"@items\",\"@columns\",\"@showTimeRead\",\"@order\",\"@asc\"],[[30,0,[\"model\"]],[30,0,[\"columns\"]],[30,0,[\"showTimeRead\"]],[30,0,[\"order\"]],[30,0,[\"asc\"]]]],null],[1,\"\\n            \"],[8,[39,17],null,[[\"@condition\"],[[30,0,[\"model\",\"loadingMore\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,0],[14,0,\"empty-state\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"empty-state-body\"],[12],[1,\"\\n                \"],[10,2],[12],[1,\"\\n\"],[41,[30,0,[\"name\"]],[[[1,\"                    \"],[1,[28,[35,10],[\"directory.no_results_with_search\"],null]],[1,\"\\n\"]],[]],[[[1,\"                    \"],[1,[28,[35,10],[\"directory.no_results.body\"],null]],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"                      \"],[1,[28,[35,19],[[28,[37,10],[\"directory.no_results.extra_body\"],[[\"basePath\"],[[28,[37,20],null,null]]]]],null]],[1,\"\\n\"]],[]],null]],[]]],[1,\"                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[],false,[\"if\",\"hide-application-footer\",\"body-class\",\"load-more\",\"action\",\"plugin-outlet\",\"hash\",\"period-chooser\",\"fn\",\"mut\",\"i18n\",\"input\",\"readonly\",\"on\",\"with-event-value\",\"combo-box\",\"d-button\",\"conditional-loading-spinner\",\"directory-table\",\"html-safe\",\"base-path\"]]",
  "moduleName": "discourse/templates/users.hbs",
  "isStrictMode": false
});